import { Routes, Route } from "react-router-dom";
import "./App.css";
import Sidebar from "./Layout/DigitalMarketing/Sidebar";
import Customer from "./Pages/DigitalMarket/Customer/index";
import "../src/assets/DigitalMarketing/Css/Style.css";
import Dashboard from "./Pages/DigitalMarket/Dashboard/index";
import Database from "./Pages/DigitalMarket/Database/index";
import PotentialLeads from "./Pages/DigitalMarket/PotentialLeads/index";
import Ivf from "./Pages/DigitalMarket/Ivr-journey-stage/index";
import Branches from "./Pages/DigitalMarket/Branches/index";
import Login from "./Pages/DigitalMarket/Auth/login";
import AuthGuard from "./Guard/auth";
import TechBridge from "./Pages/DigitalMarket/Dashboard/tech-bridge";
import SpotlightAnalytics from "./Pages/DigitalMarket/Dashboard/spotlight-analytics";
import SocialMediaAnalytics from "./Pages/DigitalMarket/Dashboard/socialmedia-analytics";
import MimoAnalytics from "./Pages/DigitalMarket/Dashboard/mimo-analytics";
import AnalyticsComponent from "./Pages/DigitalMarket/Dashboard/socialmedia-analytics/AnalyticsComponent";
import SourceMaster from "./Pages/DigitalMarket/Source-Master";
import Reports from "./Pages/DigitalMarket/Reports";
import UserManagement from "./Pages/DigitalMarket/User-Management";
import Appoinment from "./Pages/DigitalMarket/Appoinment";
import UpdateAppoinment from "./Pages/DigitalMarket/Appoinment/UpdateAppoinment";
import Settings from "./Pages/DigitalMarket/Settings";
import Integration from "./Pages/DigitalMarket/Integration";
import FacebookDetail from "./Pages/DigitalMarket/Integration/FacebookDetail";
import ChatbotDetail from "./Pages/DigitalMarket/Integration/ChatbotDetail";
import RoleMangement from "./Pages/DigitalMarket/Role-Mangement";
import PermissionManager from "./Pages/DigitalMarket/PermissionManagement";
import GoogleDetail from "./Pages/DigitalMarket/Integration/GoogleDetail";
import Treatments from "./Pages/DigitalMarket/Treatments";
import AppoinmentBooking from "./Pages/LandingScreens/Appoinment/AppointmentBooking";
import AppoinmentConfirm from "./Pages/LandingScreens/Appoinment/AppointmentConfirm";
import Reminder from "./Pages/DigitalMarket/Reminder";
import UpdateReminder from "./Pages/DigitalMarket/Reminder/UpdateReminder";
import WellnessTips from "./Pages/DigitalMarket/Wellness-tips";
import WhatsappDetail from "./Pages/DigitalMarket/Integration/WhatsappDetail";
import MedicineMaster from "./Pages/DigitalMarket/Medicine-master";
import CustomerJourney from "./Pages/DigitalMarket/Customer-Journey";
import BloodTest from "./Pages/DigitalMarket/BloodTest";
import UpdateBloodAppointment from "./Pages/DigitalMarket/BloodTest/UpdateBloodAppointment";
import ProcedureTemplates from "./Pages/DigitalMarket/Masters/ProcedureTemplates";
import EhrTemplates from "./Pages/DigitalMarket/Masters/EhrTemplates";
import Locations from "./Pages/DigitalMarket/Masters/Locations";
import { useState } from "react";
import ConsultantList from "./Pages/DigitalMarket/ConsultantMaster";
import PatientList from "./Pages/DigitalMarket/PatientMaster";
import PatientTemplates from "./Pages/DigitalMarket/PatientMaster/PatientDetail";
import InvoicesList from "./Pages/DigitalMarket/Invoices";
import Appointment from "./Pages/DigitalMarket/AppointmentList";
import ViewConsultant from "./Pages/DigitalMarket/ConsultantMaster/ViewConsultant";
import MyLabs from "./Pages/DigitalMarket/LabsManagement/MyLabs";
import PrescribedTests from "./Pages/DigitalMarket/LabsManagement/PrescribedTests";
import TestOrders from "./Pages/DigitalMarket/LabsManagement/TestOrders";
import TestPackages from "./Pages/DigitalMarket/LabsManagement/TestPackages";
import CarePackages from "./Pages/DigitalMarket/CarePackages";
import CustomerViewDetails from "./Pages/DigitalMarket/Customer/CustomerViewDetails";
import MimoKonnect from "./Pages/DigitalMarket/Dashboard/MimoKonnect";
import NewReports from "./Pages/DigitalMarket/NewReports";
import SuccessPage from "./Pages/DigitalMarket/AppointmentList/SuccessPage";
import ConsultantExpenses from "./Pages/DigitalMarket/ConsultantExpense";
import ConsultantAppointment from "./Pages/DigitalMarket/ConsultantAppointment";

function App() {
  const [updatedData, setUpdateData] = useState<any>([]);
  const [showAddType, setShowAddType] = useState("");
  console.log(updatedData, "updatedData");
  return (
    <div className="App">
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="/:id/:role" element={<AppoinmentBooking />} />
        <Route path="/:id/confirmed" element={<AppoinmentConfirm />} />
        <Route path="analysis" element={<AnalyticsComponent />} />
        <Route
          path="/"
          element={
            <AuthGuard>
              <Sidebar />
            </AuthGuard>
          }
        >
          <Route
            index
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="dashboard"
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="tech-bridge"
            element={
              <AuthGuard>
                <MimoKonnect />
              </AuthGuard>
            }
          />
          <Route
            path="mimo-analytics"
            element={
              <AuthGuard>
                <MimoAnalytics />
              </AuthGuard>
            }
          />
          <Route
            path="socialmedia-analytics"
            element={
              <AuthGuard>
                <SocialMediaAnalytics />
              </AuthGuard>
            }
          />
          <Route
            path="spotlight-analytics"
            element={
              <AuthGuard>
                <SpotlightAnalytics />
              </AuthGuard>
            }
          />
          <Route
            path="branches"
            element={
              <AuthGuard>
                <Branches />
              </AuthGuard>
            }
          />
          <Route
            path="branches/:id"
            element={
              <AuthGuard>
                <Branches />
              </AuthGuard>
            }
          />
          {/* <Route path="dashboard/customer" element={
            <AuthGuard>
              <Customer />
            </AuthGuard>
          } />
          <Route path="dashboard/customer/:id" element={
            <AuthGuard>
              <Customer />
            </AuthGuard>} /> */}
          <Route
            path="lead-management"
            element={
              <AuthGuard>
                <Database
                  setUpdateData={setUpdateData}
                  setShowAddType={setShowAddType}
                  showAddType={showAddType}
                />
              </AuthGuard>
            }
          />
          <Route
            path="potential-leads"
            element={
              <AuthGuard>
                <PotentialLeads />
              </AuthGuard>
            }
          />
          <Route
            path="treatment-journey-stages"
            element={
              <AuthGuard>
                <Ivf />
              </AuthGuard>
            }
          />
          <Route
            path="medicine-master"
            element={
              <AuthGuard>
                <MedicineMaster />
              </AuthGuard>
            }
          />
          <Route
            path="procedure-templates"
            element={
              <AuthGuard>
                <ProcedureTemplates />
              </AuthGuard>
            }
          />
          <Route
            path="ehr-templates"
            element={
              <AuthGuard>
                <EhrTemplates />
              </AuthGuard>
            }
          />
          <Route
            path="patient-list/patient-details/:id"
            element={
              <AuthGuard>
                <PatientTemplates />
              </AuthGuard>
            }
          />
          <Route
            path="invoice-list"
            element={
              <AuthGuard>
                <InvoicesList />
              </AuthGuard>
            }
          />
          <Route
            path="locations"
            element={
              <AuthGuard>
                <Locations />
              </AuthGuard>
            }
          />
          <Route
            path="consultant-list"
            element={
              <AuthGuard>
                <ConsultantList />
              </AuthGuard>
            }
          />
          <Route
            path="consultant-expenses"
            element={
              <AuthGuard>
                <ConsultantExpenses />
              </AuthGuard>
            }
          />
           <Route
            path="consultant-appointment"
            element={
              <AuthGuard>
                <ConsultantAppointment />
              </AuthGuard>
            }
          />
          <Route
            path="consultant-list/view/:id"
            element={
              <AuthGuard>
                <ViewConsultant />
              </AuthGuard>
            }
          />{" "}
          <Route
            path="patient-list"
            element={
              <AuthGuard>
                <PatientList />
              </AuthGuard>
            }
          />
          <Route
            path="appointment-list"
            element={
              <AuthGuard>
                <Appointment />
              </AuthGuard>
            }
          />
          <Route
            path="customer-journey"
            element={
              <AuthGuard>
                <CustomerJourney />
              </AuthGuard>
            }
          />
          <Route
            path="blood-test-collection"
            element={
              <AuthGuard>
                <BloodTest />
              </AuthGuard>
            }
          />
          <Route
            path="blood-test-collection/add"
            element={
              <AuthGuard>
                <UpdateBloodAppointment />
              </AuthGuard>
            }
          />
          <Route
            path="blood-test-collection/reschedule/:id"
            element={
              <AuthGuard>
                <UpdateBloodAppointment />
              </AuthGuard>
            }
          />
          <Route
            path="dashboard/tech-bridge"
            element={
              <AuthGuard>
                <TechBridge />
              </AuthGuard>
            }
          />
          <Route
            path="dashboard/mimo-analytics"
            element={
              <AuthGuard>
                <MimoAnalytics />
              </AuthGuard>
            }
          />
          <Route
            path="dashboard/socialmedia-analytics"
            element={
              <AuthGuard>
                <SocialMediaAnalytics />
              </AuthGuard>
            }
          />
          <Route
            path="lead-management/customer/:type"
            element={
              <AuthGuard>
                <Customer />
              </AuthGuard>
            }
          />
          <Route
            path="lead-management/customer/:type/:id"
            element={
              <AuthGuard>
                <Customer />
              </AuthGuard>
            }
          />
          <Route
            path="customer/:type"
            element={
              <AuthGuard>
                <Customer />
              </AuthGuard>
            }
          />
          <Route
            path="source-master"
            element={
              <AuthGuard>
                <SourceMaster />
              </AuthGuard>
            }
          />
          <Route
            path="integration"
            element={
              <AuthGuard>
                <Integration />
              </AuthGuard>
            }
          />
          <Route
            path="integration/facebook"
            element={
              <AuthGuard>
                <FacebookDetail />
              </AuthGuard>
            }
          />
          <Route
            path="integration/chatbot"
            element={
              <AuthGuard>
                <ChatbotDetail />
              </AuthGuard>
            }
          />
          <Route
            path="integration/whatsapp"
            element={
              <AuthGuard>
                <WhatsappDetail />
              </AuthGuard>
            }
          />
          <Route
            path="integration/google"
            element={
              <AuthGuard>
                <GoogleDetail />
              </AuthGuard>
            }
          />
          <Route
            path="appointment-index"
            element={
              <AuthGuard>
                <Appoinment />
              </AuthGuard>
            }
          />
          <Route
            path="wellness-tips"
            element={
              <AuthGuard>
                <WellnessTips />
              </AuthGuard>
            }
          />
          <Route
            path="reminder-index"
            element={
              <AuthGuard>
                <Reminder />
              </AuthGuard>
            }
          />
          <Route
            path="treatment"
            element={
              <AuthGuard>
                <Treatments />
              </AuthGuard>
            }
          />
          <Route
            path="appointment-index/add"
            element={
              <AuthGuard>
                <UpdateAppoinment />
              </AuthGuard>
            }
          />
          <Route
            path="appointment-index/reschedule/:id"
            element={
              <AuthGuard>
                <UpdateAppoinment />
              </AuthGuard>
            }
          />
          <Route
            path="reminder-index/add"
            element={
              <AuthGuard>
                <UpdateReminder />
              </AuthGuard>
            }
          />
          <Route
            path="reports"
            element={
              <AuthGuard>
                <NewReports />
              </AuthGuard>
            }
          />
          <Route
            path="role-management"
            element={
              <AuthGuard>
                <RoleMangement />
              </AuthGuard>
            }
          />
          <Route
            path="permission-management"
            element={
              <AuthGuard>
                <PermissionManager />
              </AuthGuard>
            }
          />
           <Route
            path="meetsuccess"
            element={
              <AuthGuard>
                <SuccessPage />
              </AuthGuard>
            }
          />
          <Route
            path="user-management"
            element={
              <AuthGuard>
                <UserManagement />
              </AuthGuard>
            }
          />
          <Route
            path="settings"
            element={
              <AuthGuard>
                <Settings />
              </AuthGuard>
            }
          />
          <Route
            path="customer/:type/:id"
            element={
              <AuthGuard>
                <Customer />
              </AuthGuard>
            }
          />
          <Route
            path="lead-management/customerview/:type/:id"
            element={
              <AuthGuard>
                <CustomerViewDetails />
              </AuthGuard>
            }
          />
          <Route
            path="my-labs"
            element={
              <AuthGuard>
                <MyLabs />
              </AuthGuard>
            }
          />
          <Route
            path="prescribed-tests"
            element={
              <AuthGuard>
                <PrescribedTests />
              </AuthGuard>
            }
          />
          <Route
            path="test-orders"
            element={
              <AuthGuard>
                <TestOrders />
              </AuthGuard>
            }
          />
          <Route
            path="test-packages"
            element={
              <AuthGuard>
                <TestPackages />
              </AuthGuard>
            }
          />
          <Route
            path="care-packages"
            element={
              <AuthGuard>
                <CarePackages />
              </AuthGuard>
            }
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
